import { render, staticRenderFns } from "./InnovationCard.vue?vue&type=template&id=2d4ac578&scoped=true"
import script from "./InnovationCard.vue?vue&type=script&lang=ts"
export * from "./InnovationCard.vue?vue&type=script&lang=ts"
import style0 from "./InnovationCard.vue?vue&type=style&index=0&id=2d4ac578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ac578",
  null
  
)

export default component.exports